module.exports = __webpack_public_path__ + "img/settingsWhite.a702ccf0.svg";